<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        class="woom-bike-outline woom-original-4"
        viewBox="0 0 800 600"
        style="enable-background: new 0 0 800 600"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M277.5,397.3c-8.6,55.2-56.3,97.5-114,97.5c-63.7,0-115.4-51.6-115.4-115.4s51.6-115.4,115.4-115.4
					c39.6,0,74.6,20,95.4,50.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M264.2,323c9.4,16.7,14.7,36,14.7,56.5c0,1.3,0,2.5-0.1,3.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M298.1,399.8c-9.8,65.5-66.3,115.7-134.6,115.7c-75.2,0-136.1-60.9-136.1-136.1s60.9-136.1,136.1-136.1
					c48,0,90.2,24.8,114.4,62.4" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M283.7,315.5c10.5,19.3,15.9,40.5,15.9,64c0,1.8,0,3.6-0.1,5.4" />
            </g>
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M592.1,272.9c13.6-5.7,28.6-8.8,44.3-8.8c63.7,0,115.4,51.6,115.4,115.4s-51.6,115.4-115.4,115.4
					s-115.4-51.6-115.4-115.4c0-40,19.7-74.8,50.7-95.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M582.5,254.4c16.5-7.1,34.7-11.1,53.9-11.1c75.2,0,136.1,60.9,136.1,136.1s-60.9,136.1-136.1,136.1
					s-136.1-60.9-136.1-136.1c0-48.1,24.9-90.4,62.6-114.6" />
            </g>
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M346.8,388.5l-28.9-88.7L186,356.6c0,0-10.3,6.3-9.7,10.9c0.6,4.6,3.4,7.9,10.2,8.4S346.8,388.5,346.8,388.5z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M328.7,275.1l33,101.8l170.5-180l-4.6-11.5l-138,81c0,0-15.8,8.8-27.9,8.8
				C349.5,275.1,328.7,275.1,328.7,275.1z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M375,398.9l167.3-177.4l1,8l1.8,2.4l23.9-9.6l-4.8-8.9l-22.4-54.2l-1-6.5l-1.6-3.2l-23.1,9.3l3.3,9.4
				c0,0-128.7,76.4-135.2,80.2c-6.5,3.9-14.7,9.1-28.4,9.1c-13.8,0-32.9-0.1-32.9-0.1l-5-15.2l-16.8,5.4l13.2,41.2l-133.7,62.1
				c0,0-20.5,10.7-23.1,17c-1.2,2.9-1.4,3.6,0.2,4.7c1.4,1.1,7.2-7.7,9.3-8c2.2-0.3,4.7,1.2,4.3,5c-0.5,3.9-2.7,14.4-2.7,14.4
				l183.1,22.1" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M552.3,243.3l22.2,45l44.8,79.3l14.5-7.4l-47.7-99.9l-16.1-26.5c0,0-3.8-5.7-10.9-2.4
				C554.4,233.6,549.9,236.9,552.3,243.3z" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="545.1"
                y1="231.8"
                x2="555.5"
                y2="249.8" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="569"
                y1="222.2"
                x2="575.8"
                y2="243.3" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M408.8,445.8c-0.2,0.3-0.5,0.7-0.8,1c-3.8,4.2-10.7-0.8-10.7-0.8" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M385.4,435.7c-12.8-11.1-31.7-27.5-33.7-29.4c-3-2.9-6.3-10.6-0.3-16.5c6-5.9,12.7-2.5,14.5-0.8l41.5,46.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M335.1,387.6c0,0-22.7-25.8-25.1-28.6s-2.8-7.4,0.9-10.3c3.7-2.9,8-1,11.5,2.2c4.2,4,17,14.6,17,14.6" />
            <rect
                x="376.6"
                y="435.8"
                class="fill-none stroke-woom-black stroke-2"
                width="52.2"
                height="10" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="311"
                y1="360.1"
                x2="299.1"
                y2="360.1" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="337.5"
                y1="360.1"
                x2="332.8"
                y2="360.1" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="296.6"
                y1="350.1"
                x2="309.1"
                y2="350.1" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="321.6"
                y1="350.1"
                x2="334.1"
                y2="350.1" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M620.8,366.9l0.5,3.1c0,0,5.6,12,7.2,13.5s4.8,3.1,5.8,3c1,0-2-6.5-2-6.5s-0.8-2.7,0.8-3.7s3.2-0.6,4.1,0.9
				c0.8,1.5,2.7,6.1,3.4,6.2c0.8,0,2.7-1.8,1.9-6s-6.7-14.7-6.7-14.7l-3.8-1.5" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="516.2,158.7 513.1,151.8 533.1,143.8 538.4,146.9 539.2,149.4" />
            <circle
                class="fill-none stroke-woom-black stroke-2"
                cx="359.5"
                cy="398"
                r="6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M448.2,315.4l-0.9,0.8c-0.2,0.2-0.4,0.2-0.7,0l-6.9-4.1c-2.3-1.4-5-1.5-7.4,0.5c-1.2,1-1.9,2.4-2,3.9
				c-1.7,0-3.3,0.7-4.3,1.5c-2.4,2.1-3.1,4.8-1.8,7.1c-2.7-1-5.8-0.6-8.1,1.4c-2.2,1.9-3.1,4.8-2.6,7.5c-2.6-0.9-5.6-0.4-7.8,1.5
				c-2.2,1.9-3.1,4.8-2.6,7.5l-1.3-1.5c-0.7-0.8-1.9-0.9-2.7-0.2c-0.8,0.7-0.9,1.9-0.2,2.7l5.4,6.3c0.8,1,0.5,2.4-0.4,3.2
				c-0.8,0.7-2.4,0.8-3.2-0.1l-0.1-0.1l-5.4-6.3c-0.7-0.8-1.9-0.9-2.7-0.2c-0.8,0.7-0.9,1.9-0.2,2.7l5.4,6.3l0.1,0.1
				c0.9,1,0.5,2.4-0.2,3.1s-1.7,0.8-2.9,0.1l-7.4-4.5c-1.8-1.1-3.4-0.2-4,0.3l-1.6,1.3c-0.8,0.7-0.9,1.9-0.2,2.7
				c0.7,0.8,1.9,0.9,2.7,0.2l0.9-0.8c0.2-0.2,0.4-0.2,0.7,0l6.9,4.1c2.3,1.4,5,1.5,7.4-0.5c1.2-1,1.9-2.4,2-3.9c1.7,0,3.3-0.7,4.3-1.5
				c2.4-2.1,3.1-4.8,1.8-7.1c2.7,1,5.8,0.6,8.1-1.4c2.2-1.9,3.1-4.8,2.7-7.5c2.6,0.9,5.6,0.4,7.8-1.5c2.2-1.9,3.1-4.8,2.7-7.5l1.3,1.5
				c0.7,0.8,1.9,0.9,2.7,0.2c0.8-0.7,0.9-1.9,0.2-2.7l-5.4-6.3c-0.8-1-0.5-2.4,0.4-3.2c0.8-0.7,2.4-0.8,3.2,0.1l0.1,0.1l5.4,6.3
				c0.7,0.8,1.9,0.9,2.7,0.2c0.8-0.7,0.9-1.9,0.2-2.7l-5.4-6.3l-0.1-0.1c-0.9-1-0.5-2.4,0.2-3.1c0.7-0.6,1.7-0.8,2.9-0.1l7.4,4.5
				c1.8,1.1,3.4,0.2,4-0.3l1.6-1.3c0.8-0.7,0.9-1.9,0.2-2.7C450.2,314.8,449,314.7,448.2,315.4z M413.7,344.9c-1.7,1.5-4.4,1.3-6-0.5
				c-1.5-1.8-1.3-4.5,0.4-6c1.8-1.5,4.4-1.3,6,0.5C415.7,340.7,415.5,343.4,413.7,344.9z M424.1,336c-1.7,1.5-4.4,1.3-6-0.5
				c-1.5-1.8-1.3-4.5,0.4-6c1.8-1.5,4.4-1.3,6,0.5C426.1,331.8,425.9,334.5,424.1,336z" />
        </g>
        <g class="saddle-normal">
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="316.4,241.7 303.9,204.5 289.4,207.6 302.1,246.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M253.6,170.7c0,0,34.8,3.5,56,4.1c21.3,0.5,38.7,0.6,42.2,0.5c3.5-0.1,9.1,3.9,9.3,8.5
				c0.2,4.7-5.1,3.6-6.8,3.6s-22.7-0.7-40.4,6.4s-18.3,9.1-32,8.9c-2.6,0-5.2-0.2-7.8-0.5c-10.9-1.4-21.1-5.2-28.1-11.6
				c-8.7-7.9-8.8-8.2-7.5-12C239.8,174.6,238.9,169.3,253.6,170.7z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M272.5,202.6c2,3.1-1.3,6.4,10.6,5.1c11.9-1.3,24.5-3.8,30.1-5.9c5.6-2.1,12.1-10.9,12.1-10.9" />
        </g>
        <g class="handlebar-normal">
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="532.8,117.7 509.8,135 508.3,140.7 513.1,151.8" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M533.1,143.8c0,0-2-2.6,1.9-5.6s10.2-7.8,10.2-7.8" />
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M516.1,103.6c0,0-1.5,12.5,2.9,12.9c4.4,0.4,8.3-4.4,15.8,0.5c7.5,4.9,8.5,8.2,8.5,8.2l-1.6,3.7l4.7,1.9
					c0,0,7.4-6.4,8.5-9.1c1.2-2.7,2.7-11.5-6.8-12.7c-9.5-1.2-15.8-5.2-16.9-6.7" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M514.4,89.3c0,0,8.4-3,11.7,1.3c3.2,4.3,5.7,12.6,5.5,15.7c-0.1,3.1-1.2,7.4-5.4,8.1
					c-4.2,0.7-9.1-1.6-10.6-10" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="504.2"
                    cy="97.7"
                    r="13.2" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="547.6"
                    cy="116.9"
                    r="5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M510.6,85.7c0,0,6.1-2.6,9.3,2.3" />
            </g>
        </g>
        <g class="tyres hidden">
            <g class="inline">
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="165.1"
                        y1="243.3"
                        x2="165.1"
                        y2="515.5" />
                    <g>
                        <rect
                            x="157.3"
                            y="242.1"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                    <g>
                        <rect
                            x="157.3"
                            y="514.3"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                </g>
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="635.2"
                        y1="243.3"
                        x2="635.2"
                        y2="515.5" />
                    <g>
                        <rect
                            x="627.4"
                            y="242.1"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                    <g>
                        <rect
                            x="627.4"
                            y="514.3"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                </g>
            </g>
        </g>
        <g class="cockpit hidden">
            <g class="inline">
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="504.6"
                    y1="97.7"
                    x2="504.6"
                    y2="511.5" />
                <g>
                    <rect
                        x="496.8"
                        y="96.5"
                        class="fill-woom-red stroke-woom-red"
                        width="15.6"
                        height="2.4" />
                </g>
                <g>
                    <rect
                        x="496.8"
                        y="510.3"
                        class="fill-woom-red stroke-woom-red"
                        width="15.6"
                        height="2.4" />
                </g>
            </g>
        </g>
        <g class="steering-angle hidden">
            <g class="inline">
                <g>
                    <g>
                        <polyline
                            class="h-line-miter fill-none stroke-woom-red stroke-3"
                            points="497.8,97.7 556.8,223.8 431.7,223.8" />
                    </g>
                    <path
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        d="M507.9,223.5c0-19.5,11.6-36.4,28.2-44" />
                </g>
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="558.7"
                            y1="229.5"
                            x2="560.5"
                            y2="233.1" />
                        <line
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            x1="564"
                            y1="240.3"
                            x2="696.9"
                            y2="508.2" />
                        <polyline
                            class="h-line fill-none stroke-woom-red stroke-3"
                            points="698.6,511.8 700.4,515.3 696.4,515.3" />
                        <line
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            x1="688.2"
                            y1="515.3"
                            x2="577.4"
                            y2="515.3" />
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="573.3"
                            y1="515.3"
                            x2="569.3"
                            y2="515.3" />
                    </g>
                    <g>
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M644.9,515.5c0-1.3,0.1-2.7,0.2-4" />
                        <path
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            d="M646.7,502.2c3.1-10.8,9.8-20.1,18.8-26.4" />
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M669.6,473.3c1.2-0.7,2.3-1.3,3.6-1.8" />
                    </g>
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g class="inline">
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="522.6"
                    y1="138"
                    x2="286"
                    y2="138" />
                <g>
                    <rect
                        x="521.4"
                        y="130.2"
                        class="fill-woom-red stroke-woom-red"
                        width="2.4"
                        height="15.6" />
                </g>
                <g>
                    <rect
                        x="284.8"
                        y="130.2"
                        class="fill-woom-red stroke-woom-red"
                        width="2.4"
                        height="15.6" />
                </g>
            </g>
        </g>
        <g class="wheelbase hidden">
            <g class="inline">
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="632.4"
                    y1="375"
                    x2="166.3"
                    y2="375" />
                <g>
                    <rect
                        x="631.2"
                        y="367.2"
                        class="fill-woom-red stroke-woom-red"
                        width="2.4"
                        height="15.6" />
                </g>
                <g>
                    <rect
                        x="165.1"
                        y="367.2"
                        class="fill-woom-red stroke-woom-red"
                        width="2.4"
                        height="15.6" />
                </g>
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g class="inline">
                <g>
                    <polyline
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        points="311,249.8 397.3,515.5 164,515.5" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M348.3,514.4c0-22.2,12.2-39.6,31.1-48.3" />
            </g>
        </g>
        <g class="min-saddle-height hidden">
            <g class="inline">
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="301"
                        y1="193.6"
                        x2="296.8"
                        y2="193.6" />
                    <line
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        x1="288.1"
                        y1="193.6"
                        x2="31.7"
                        y2="193.6" />
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="27.4"
                        y1="193.6"
                        x2="23.1"
                        y2="193.6" />
                </g>
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="10"
                        y1="193.6"
                        x2="10"
                        y2="515.5" />
                    <g>
                        <rect
                            x="2.2"
                            y="192.4"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                    <g>
                        <rect
                            x="2.2"
                            y="514.3"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                </g>
            </g>
            <g class="inline">
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="316.4,241.7 310.9,224.5 296.4,227.6 302.1,246.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M260.6,190.7c0,0,34.8,3.5,56,4.1c21.3,0.5,38.7,0.6,42.2,0.5c3.5-0.1,9.1,3.9,9.3,8.5
					c0.2,4.7-5.1,3.6-6.8,3.6s-22.7-0.7-40.4,6.4s-18.3,9.1-32,8.9c-2.6,0-5.2-0.2-7.8-0.5c-10.9-1.4-21.1-5.2-28.1-11.6
					c-8.7-7.9-8.8-8.2-7.5-12C246.8,194.6,245.9,189.3,260.6,190.7z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M279.5,222.6c2,3.1-1.3,6.4,10.6,5.1c11.9-1.3,24.5-3.8,30.1-5.9c5.6-2.1,12.1-10.9,12.1-10.9" />
            </g>
        </g>
        <g class="max-saddle-height hidden">
            <g class="inline">
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="281"
                        y1="143.8"
                        x2="276.5"
                        y2="143.8" />
                    <line
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        x1="267.2"
                        y1="143.8"
                        x2="32.3"
                        y2="143.8" />
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="27.7"
                        y1="143.8"
                        x2="23.1"
                        y2="143.8" />
                </g>
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="10"
                        y1="143.8"
                        x2="10"
                        y2="515.5" />
                    <g>
                        <rect
                            x="2.2"
                            y="142.6"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                    <g>
                        <rect
                            x="2.2"
                            y="514.3"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                </g>
            </g>
            <g class="inline">
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="316.4,241.7 293.9,174.5 279.4,177.6 302.1,246.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M243.6,140.7c0,0,34.8,3.5,56,4.1c21.3,0.5,38.7,0.6,42.2,0.5c3.5-0.1,9.1,3.9,9.3,8.5
					c0.2,4.7-5.1,3.6-6.8,3.6s-22.7-0.7-40.4,6.4s-18.3,9.1-32,8.9c-2.6,0-5.2-0.2-7.8-0.5c-10.9-1.4-21.1-5.2-28.1-11.6
					c-8.7-7.9-8.8-8.2-7.5-12C229.8,144.6,228.9,139.3,243.6,140.7z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M262.5,172.6c2,3.1-1.3,6.4,10.6,5.1c11.9-1.3,24.5-3.8,30.1-5.9c5.6-2.1,12.1-10.9,12.1-10.9" />
            </g>
        </g>
        <g class="crank-length hidden">
            <g class="inline">
                <line
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    x1="358.8"
                    y1="397.2"
                    x2="404.9"
                    y2="442.4" />
                <g>
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="352.8,401.7 363.1,391.2 364.7,392.8 354.4,403.3" />
                </g>
                <g>
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="399,446.9 409.3,436.4 410.9,438 400.6,448.5" />
                </g>
            </g>
        </g>
        <g class="handlebar-adjustability hidden">
            <g class="inline">
                <path
                    class="h-line fill-none stroke-woom-red stroke-3"
                    d="M534.9,37.6c23.4,2.1,42,20.7,44.1,44.1" />
                <g>
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="536.2,43.7 526.4,36.8 537.2,31.8" />
                </g>
                <g>
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="572.9,80.5 579.8,90.3 584.8,79.4" />
                </g>
            </g>
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M540.3,83.6c0,0-11.1,6-8.9,9.8c2.2,3.8,8.4,4.3,8.6,13.2s-1.9,11.7-1.9,11.7l-3.9,0.8l1.1,4.9
					c0,0,9.4,2.4,12.3,1.8c2.9-0.6,11-4.4,6.5-12.8s-4.8-16-4.1-17.7" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M551,74.1c0,0,7.2,5.2,5.6,10.3c-1.7,5.1-7.1,11.9-9.7,13.5s-6.7,3.2-9.7,0.2c-3-3-3.9-8.4,2.2-14.4" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="538.3"
                    cy="70.5"
                    r="13.2" />
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="547.3"
                    cy="117.1"
                    r="5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M551.8,68.9c0,0,5.6,3.6,3.4,9" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="539.9,111.6 509.8,135 508.3,140.7 513.1,151.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M533.1,143.8c0,0-2-2.6,1.9-5.6s14.8-13.1,14.8-13.1" />
            </g>
        </g>
        <g class="stand-over-height hidden">
            <g>
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="10"
                        y1="233.9"
                        x2="10"
                        y2="512.4" />
                    <g>
                        <rect
                            x="2.2"
                            y="232.7"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                    <g>
                        <rect
                            x="2.2"
                            y="511.2"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.4" />
                    </g>
                </g>
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="405.5"
                        y1="233.8"
                        x2="400.8"
                        y2="233.8" />
                    <line
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        x1="391.2"
                        y1="233.8"
                        x2="32.4"
                        y2="233.8" />
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="27.6"
                        y1="233.8"
                        x2="22.9"
                        y2="233.8" />
                </g>
            </g>
        </g>
    </svg>
</template>
